import React, { Component } from 'react';
import SearchInput from './SearchInput';

class HighSearchInput extends Component {
    state = {
        id: '',
        options: [],
    }

    handleChange = (force = false) => {
        const { id, options } = this.state;
        if (force || id !== '') {
            this.props.onChange(id, options);
        }
    }

    selectChange = value => {
        let id;
        if (value) {
            id = value.key;
        } else {
            id = '';
        }
        this.setState({ id }, () => {
            this.handleChange(true);
        });
    }

    parseData = (res, value) => {
        const { name: typeName, config: { id, name, code, type } } = this.props;
        let options;
        if ((res.data || res.datas || res.doctors) ) {
            let sourceData;
            if (type === 'projectPercent') {
                sourceData = res.data.siteList.datas;
            } else if (type == 'hospital') {
                sourceData = res.data.hospitalList.datas;
            } else if (type == 'researcher') {
                sourceData = res.doctors;
            } else {
                sourceData = res.data ? res.data: res.datas;
            }
            options = (sourceData || []).map(item => {
                const param = {
                    ...item,
                    text: item[name],
                    value: item[id],
                };
                if (typeName === 'user') {
                    param.text = `${item[name]}[${item[code]}]`;
                } else if (typeName === 'site') {
                    param.text = `${item[name]}-(${item[code]})`;
                }
                return param;
            });
        } else {
            options = [];
        }
        this.setState({ options }, () => {
            this.handleChange();
        });
    }

    render() {
        const {
            url = '',
            name = '',
            isEdit = false,
            keyword = '',
            style = { width: 200 },
            placeholder = '输入自动检索',
            params = {},
            initValue = {},
            disabled = false,
            onFocus,
        } = this.props;
        const { options } = this.state;
        return (
            <SearchInput
                name={name}
                isEdit={isEdit}
                keyword={keyword}
                style={style}
                placeholder={placeholder}
                params={params}
                url={url}
                disabled={disabled}
                initValue={initValue}
                dataSource={options}
                parseData={this.parseData}
                handleSelect={this.selectChange}
                handleFocus={onFocus}
            />
        );
    }
}

export default HighSearchInput;


// WEBPACK FOOTER //
// ./src/components/common/HighSearchInput.js